import React, { useState } from 'react';
import api from '../../services/api';
import { useAuth } from '../../context/AuthContext';

/**
 * "Assign to me" / "Assigned to you" toggle for a conversation.
 * commons #205: assignment had an API and a filter chip but no control.
 * Shared by the thread header and the context rail's escalation card.
 */
function AssignControl({ conversation, practiceId, onChanged, className = 'btn ghost' }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const assignedTo = conversation.assigned_to_user_id || null;
  const mine = user?.id != null && String(assignedTo) === String(user.id);

  const toggle = async () => {
    setBusy(true);
    try {
      await api.assignSmsConversation(conversation.id, mine ? null : user?.id, practiceId);
      if (onChanged) onChanged();
    } catch (err) {
      alert('Assign failed: ' + (err.message || 'unknown error'));
    } finally {
      setBusy(false);
    }
  };

  if (assignedTo && !mine) {
    const other = conversation.assigned_to_name || `user #${assignedTo}`;
    return <span className={className} title={`Assigned to ${other}`}>Assigned to {other}</span>;
  }
  return (
    <button type="button" className={className} onClick={toggle} disabled={busy || !user?.id}>
      {busy ? '…' : mine ? '✓ Assigned to you' : 'Assign to me'}
    </button>
  );
}

export default AssignControl;
